import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {deleteCategory, hideDeleteCategoryModal} from "./actions";
import DeleteFormModal from "../common/DeleteFormModal";

const DeleteCategoryModal = ({
                            onDelete,
                            category,
                            categoryDeleting,
                            hideDeleteCategoryModal,
                            deleteCategory,
                            visible
                          }) => {
  const categoryHandle = {categoryId: category.categoryId};
  return (
    <DeleteFormModal entityType="Category" entityName={category.name} entityHandle={categoryHandle} visible={visible}
                     entityDeleting={categoryDeleting} deleteEntity={deleteCategory}
                     hideDeleteFormModal={hideDeleteCategoryModal} onDelete={onDelete}/>);
};

DeleteCategoryModal.propTypes = {
  onDelete: PropTypes.func.isRequired,
  /* state */
  visible: PropTypes.bool.isRequired,
  category: PropTypes.object,
  categoryDeleting: PropTypes.bool.isRequired,
  /* actions */
  hideDeleteCategoryModal: PropTypes.func.isRequired,
  deleteCategory: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  visible: state.category.deleteCategoryModalVisible,
  category: state.category.categoryToDelete,
  categoryDeleting: state.category.categoryDeleting,
});

const mapDispatchToProps = dispatch => ({
  hideDeleteCategoryModal: bindActionCreators(hideDeleteCategoryModal, dispatch),
  deleteCategory: bindActionCreators(deleteCategory, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteCategoryModal);



// WEBPACK FOOTER //
// ./src/Category/DeleteCategoryFormModal.js